class CertificateForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.error = this.querySelector('.error-wrapper');
    this.batchField = this.querySelector('.certificate-form__batch-field');
    this.batchInput = this.querySelector('[name="batch"]');
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.handleVariantChange(event));
  }

  handleVariantChange(event) {
    const variant = event.data.variant;
    if (!variant) return;

    const variantId = variant.id.toString();
    const idsList = this.dataset.metaVisibility.split(',');
    const closestAccordion = this.closest(".certificate-form__row");
    for (const idString of idsList) {
      const splittedIDString = idString.split(":")
      if(splittedIDString[0] && splittedIDString[1]) {          
        if (splittedIDString[0] === variantId && splittedIDString[1].trim() === 'true') {
          closestAccordion.classList.remove('hidden');
          const skuInput = this.querySelector(".sku_certification")
          const prodNameInput = this.querySelector("#prod_name")
          if (skuInput) skuInput.value = variant.sku;
          if (prodNameInput) prodNameInput.value = variant.name
          break;
        } else {
          closestAccordion.classList.add('hidden');
        }
      }
    }
    this.updateBatchVisibility(variantId);
  }

  updateBatchVisibility(variantId) {
    if (!this.batchField || !this.batchInput || !this.dataset.batchVisibility) return;

    const idsList = this.dataset.batchVisibility.split(',');
    const batchNumberHidden = idsList.some((idString) => {
      const splittedIDString = idString.split(":");
      return splittedIDString[0] === variantId && splittedIDString[1] && splittedIDString[1].trim() === 'true';
    });

    this.batchField.classList.toggle('hidden', batchNumberHidden);
    if (batchNumberHidden) {
      this.batchField.setAttribute('aria-hidden', 'true');
    } else {
      this.batchField.removeAttribute('aria-hidden');
    }
    this.batchInput.required = !batchNumberHidden;
    this.batchInput.disabled = batchNumberHidden;
  }

  handleSubmit(event) {
    event.preventDefault();
    const formData = new FormData(this.form); 
    const queryString = new URLSearchParams(formData).toString();

    if(this.error) this.error.classList.add('hidden');
    
    fetch(`https://fs.ukryte.io/download.php?${queryString}`)
      .then((response) => {
        if (response.ok) {
          return response;
        }
        throw new Error();
      })
      .then(data => {
        window.open(data.url, "_blank");
      })
      .catch(error => {
        if(this.error) this.error.classList.remove('hidden');
      });
  }
}

customElements.define('certificate-form', CertificateForm);
